import { ServerResponse } from "http";
import { RESPONSE_CODE_REDIRECT_FOUND } from "rivals/services/base";

/**
 * Redirects to the appropriate resource on the On3 transition
 * @param res - The server response object passed on from getInitialProps
 */
export function redirectToOn3TransitionPage(
  res: ServerResponse | undefined,
  redirectPath: string = process.env.NEXT_PUBLIC_ON3_TRANSITION_PAGE_URL || ""
): void {
  if (res) {
    // Server-side redirect
    res.writeHead(RESPONSE_CODE_REDIRECT_FOUND, {
      Location: redirectPath
    });
    res.end();
  } else if (typeof window !== "undefined" && redirectPath) {
    // Client-side redirect
    {
      window.location.href = redirectPath;
    }
  }
}
